import m from 'mithril';

import { Storybook } from './storybook.ts';
import { TermComparisonPage } from './term_comparison_page.ts';
import { ScenariosPage } from './scenarios_page.ts';

window.onresize = m.redraw;

const MENU = [
    {
        href: '/termcomparison',
        title: 'Total cost vs monthly repayment',
        body: 'Sweep every term from 2 years up and see what each one costs you a month, and what it costs you in interest overall.',
    },
    {
        href: '/scenarios',
        title: 'Options other than one big mortgage',
        body: 'Compare buying the house you want outright against buying a cheaper one first and moving up.',
    },
];

const MainPage = {
    view: () =>
        m(
            '.page.page--centred',
            m('h1.page-title', 'Mortgages'),
            m(
                'p.lede',
                'Length and APR are how mortgages are advertised, and neither is the number you actually live with. These two views work in the ones you do: what leaves your account each month, and what the loan costs you in the end.',
            ),
            m(
                '.menu',
                MENU.map(({ href, title, body }) =>
                    m(
                        m.route.Link,
                        { selector: 'a.menu-card', href },
                        m(
                            '.menu-card__title',
                            m('span', title),
                            m('span.menu-card__arrow', '→'),
                        ),
                        m('.menu-card__body', body),
                    ),
                ),
            ),
        ),
};

m.route(document.body, '/', {
    '/': MainPage,
    '/termcomparison': TermComparisonPage,
    '/scenarios': ScenariosPage,
});
